<template>
    <li :class="{
            'show': visible,
            'mm-navigation__menu-list-item': true,
            'mm-navigation__menu-list-item--filled': isFilled,
            'mm-navigation__menu-list-item--with-icon': isWithIcon,
            'mm-navigation__menu-list-item--expander': isExpander,
            'mm-navigation__menu-list-item--with-hover': isHover,
            'mm-navigation__menu-list-item--only-icon': isOnlyIcon,
            'mm-navigation__menu-list-item--bordered': isBordered,
            'mm-navigation__menu-list-item--out-of-list': isOutOfList
        }"
        ref="dropdownMenu">
        <div class="dropdown dropdown--full" :class="{'active': visible}">
            <a  :class="dropDownElementClassValue"
                href="javascript:void(0)"
                @click="open"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <slot name="link"></slot>
            </a>

            <div class="dropdown__menu dropdown__menu--right dropdown__menu--align-left dropdown__menu--no-border dropdown__menu--dark"
                style="min-width: 200px;"
                v-if="vIfSlot === false || visible === true"
                @click="closeContentClick ? visible = !visible : null"
                aria-labelledby="navbarDropdown">
                <div  v-if="hasHeaderSlot" class="dropdown__header">
                    <slot name="header"></slot>
                    <button @click="visible = !visible" class="dropdown__header-btn">
                        <span class="icon icon-close"></span>
                    </button>
                </div>

                <slot />
            </div>
        </div>
    </li>

</template>

<script>
export default {
    props: {
        closeContentClick: {
            type: Boolean,
            default: true
        },
        closeOnRouteChange: {
            type: Boolean,
            default: true
        },
        dropdownToggle: {
            type: Boolean,
            default: false
        },
        dropDownElementClass: {
            type: String,
            default: 'nav-link'
        },
        isFilled: {
            type: Boolean,
            default: false
        },
        isWithIcon: {
            type: Boolean,
            default: false
        },
        isExpander: {
            type: Boolean,
            default: false
        },
        isHover: {
            type: Boolean,
            default: true
        },
        isOnlyIcon: {
            type: Boolean,
            default: false
        },
        isBordered: {
            type: Boolean,
            default: false
        },
        isOutOfList: {
            type: Boolean,
            default: false
        },
        vIfSlot: {
            type: Boolean,
            default: false
        },
        outerState: {
            type: Object,
            default: null
        },
        onOpen: {
            type: Function,
            default: null
        },
        onClose: {
            type: Function,
            default: null
        }
    },
    data() {
        if (this.outerState && this.outerState.visible !== undefined && this.onOpen && this.onClose) {
            return {
                visibleInner: null,
                useOutsideScope: true
            };
        } else {
            return {
                visibleInner: false,
                useOutsideScope: false
            }
        }
    },
    methods:{
        open(e) {
            e.preventDefault();
            if (this.useOutsideScope) {
                if (this.visible) {
                    this.onClose();
                } else {
                    this.onOpen();
                }
            } else {
                this.visibleInner = !this.visible;
            }
        },
        close() {
            if (this.useOutsideScope) {
                this.onClose();
            } else {
                this.visibleInner = false;
            }
        },
        documentClick(e){
            let el = this.$refs.dropdownMenu;
            let target = e.target;
            if (( el !== target) && !el.contains(target)) {
                this.close();
            }
        }
    },
    mounted () {
        document.addEventListener('click', this.documentClick);
    },
    destroyed () {
        document.removeEventListener('click', this.documentClick);
    },
    computed: {
        visible() {
            if (this.useOutsideScope) {
                if (this.outerState) {
                    return this.outerState.visible;
                } else {
                    return false;
                }
            } else {
                return this.visibleInner;
            }
        },
        hasHeaderSlot () {
            return !!this.$slots['header']
        },
        dropDownElementClassValue() {
            let className = '';
            if (this.dropDownElementClass) {
                className += ` ${this.dropDownElementClass} `;
            }
            if (this.dropdownToggle === true) {
                className += ` ${'dropdown-toggle'} `;
            }
            return className;
        }
    },
    watch:{
        /*
        $route (to, from){
            if (this.closeOnRouteChange) {
                this.close();
            }
        }
        */
    }
}
</script>

<style scoped>

.nav-item .dropdown-menu .dropdown-item {
  color: rgb(30, 30, 30);
}

.nav-item.dropdown {
  cursor: pointer;
}

.dropdown {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>


